"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _conductor = require("@virtuous/conductor");

var _context = require("../context");

var _Push = _interopRequireDefault(require("./actions/Push"));

var _Pop = _interopRequireDefault(require("./actions/Pop"));

var _Replace = _interopRequireDefault(require("./actions/Replace"));

var _Reset = _interopRequireDefault(require("./actions/Reset"));

var _ResetTo = _interopRequireDefault(require("./actions/ResetTo"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * The Router component.
 */
var Router =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Router, _React$Component);

  /**
   * @param {Object} props The component props.
   */
  function Router(props) {
    var _this;

    _classCallCheck(this, Router);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Router).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "update", function (_ref) {
      var prev = _ref.prev,
          next = _ref.next;

      _this.setState({
        prev: prev ? prev.id : null,
        next: next.id,
        updated: Date.now()
      });
    });

    if (typeof props.history === 'function') {
      _conductor.router.constructor(props.history);
    }

    _this.state = {
      prev: null,
      next: null,
      updated: null
    };
    (0, _conductor.onDidPush)(_this.update);
    (0, _conductor.onDidPop)(_this.update);
    (0, _conductor.onDidReplace)(_this.update);
    (0, _conductor.onDidReset)(_this.update);
    (0, _conductor.onUpdate)(_this.update);
    return _this;
  }
  /**
   * @param {Object} nextProps The next component props.
   * @param {Object} nextState The next component state.
   * @returns {boolean}
   */


  _createClass(Router, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      var updated = this.state.updated;
      return updated !== nextState.updated;
    }
  }, {
    key: "render",

    /**
     * @returns {JSX}
     */
    value: function render() {
      var children = this.props.children;
      var _this$state = this.state,
          prev = _this$state.prev,
          next = _this$state.next;
      var stack = Array.from(_conductor.stack.getAll());
      return _react["default"].createElement(_context.RouterContext.Provider, {
        value: {
          prev: prev,
          next: next,
          stack: stack
        }
      }, children);
    }
  }]);

  return Router;
}(_react["default"].Component);

_defineProperty(Router, "defaultProps", {
  history: null
});

_defineProperty(Router, "Push", _Push["default"]);

_defineProperty(Router, "Pop", _Pop["default"]);

_defineProperty(Router, "Replace", _Replace["default"]);

_defineProperty(Router, "Reset", _Reset["default"]);

_defineProperty(Router, "ResetTo", _ResetTo["default"]);

var _default = Router;
exports["default"] = _default;